import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12.606 20.745a.835.835 0 0 1-.929.189.835.835 0 0 1-.275-.189l-7.925-8.201a4.974 4.974 0 0 1-.945-5.778v0c.358-.71.88-1.324 1.524-1.794a5.064 5.064 0 0 1 4.536-.73 5.05 5.05 0 0 1 2.017 1.224l1.392 1.381 1.392-1.381a5.048 5.048 0 0 1 2.016-1.224 5.079 5.079 0 0 1 4.536.73 5.014 5.014 0 0 1 1.523 1.794v0a4.975 4.975 0 0 1-.944 5.778l-7.918 8.201Z"
    }, null, -1)
  ])))
}
export default { render: render }